/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styles from './styles.scss';

const DetailEye = (props) => {
  const tooltip = (
    <Tooltip id="tooltip-vd">
      <FormattedMessage
        id="lora.tooltip.viewdetail"
        defaultMessage="View detail"
      />
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <button {...props} className={`icon ${styles.btnLink}`}>
        <span className="glyphicons glyphicons-eye-open" />
      </button>
    </OverlayTrigger>
  );
};

export default DetailEye;




// WEBPACK FOOTER //
// ./src/components/DetailEye/index.jsx